import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';


const PaginatedTable = ({ sortedFeedbackData, sortConfig, setSortConfig, feedbackData }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const totalPages = Math.ceil(sortedFeedbackData.length / itemsPerPage);

  // Paginate the data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = sortedFeedbackData.slice(indexOfFirstItem, indexOfLastItem);

  // Handlers for pagination
  const goToNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const goToPreviousPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const changeItemsPerPage = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page
  };

  return (
    <div>

      {/* Table */}
      <div style={{ maxHeight: '600px', overflowY: 'auto' }}>

        <table className="table table-bordered table-hover" >
          <thead className="table-dark">
            <tr>
              <th scope="col" onClick={() => requestSort('source')} style={{ cursor: 'pointer', width: '10%' }}>
                Source {sortConfig.key === 'source' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}
              </th>
              <th scope="col" onClick={() => requestSort('message')} style={{ cursor: 'pointer' }}>
                Message {sortConfig.key === 'message' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}
              </th>
              <th scope="col" onClick={() => requestSort('is_positive')} style={{ cursor: 'pointer' }}>
                Feedback {sortConfig.key === 'is_positive' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}
              </th>
              <th scope="col" onClick={() => requestSort('timestamp')} style={{ cursor: 'pointer' }}>
                Timestamp {sortConfig.key === 'timestamp' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}
              </th>
            </tr>
          </thead>
          <tbody>
            {currentData.map((item, index) => (
              <tr key={`${item.message}-${item.timestamp}-${item.source}`}>
                <td>
                  <span className={`badge ${item.source === 'discord' ? 'bg-warning' : 'bg-info'}`}>

                    {item.source === 'discord' ? 'Discord' : 'Web App'}
                  </span>
                </td>
                <td style={{
                  width: "50%",
                  maxWidth: "300px",
                  fontSize: "0.6rem",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal"
                }}>
                  <ReactMarkdown
                    components={{
                      h1: ({ node, ...props }) => <h1 style={{ fontSize: '1rem', fontWeight: 'bold' }} {...props} />,
                      h2: ({ node, ...props }) => <h2 style={{ fontSize: '0.9rem', fontWeight: 'bold' }} {...props} />,
                      h3: ({ node, ...props }) => <h3 style={{ fontSize: '0.7rem', fontWeight: 'bold' }} {...props} />,
                      p: ({ node, ...props }) => <p style={{ fontSize: '0.6rem' }} {...props} />,
                    }}
                  >
                    {item.message}
                  </ReactMarkdown>
                </td>
                <td>
                  <span className={`badge ${item.is_positive ? 'bg-success' : 'bg-danger'}`}>
                    {item.is_positive ? "Positive" : "Negative"}
                  </span>
                </td>
                <td>{new Date(item.timestamp).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>
      {/* Pagination Controls */}
      <div className="d-flex justify-content-between align-items-center mb-3" style={{ marginTop: '25px' }}>
        <div>
          <label className="me-2">Show:</label>
          <select
            value={itemsPerPage}
            onChange={changeItemsPerPage}
            className="form-select form-select-sm"
            style={{ width: 'auto', display: 'inline-block' }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>
        <div className="text-center mt-2">
          Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, feedbackData.length)} of {feedbackData.length} entries
        </div>
        <div>
          <button
            className="btn btn-outline-secondary btn-sm me-2"
            onClick={goToPreviousPage}
            disabled={currentPage === 1}
          >
            ← Prev
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="btn btn-outline-secondary btn-sm ms-2"
            onClick={goToNextPage}
            disabled={currentPage === totalPages}
          >
            Next →
          </button>
        </div>
      </div>


    </div>
  );
};

export default PaginatedTable;
